module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('em', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter07"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('strong', [_vm._v("Part One")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_vm._v("Chapter 1:   The Week of Thanksgiving")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02"
    }
  }, [_vm._v("Chapter 2:   A Grandmother’s Welcome")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter03"
    }
  }, [_vm._v("Chapter 3:   Kieran’s Journey Begins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter04"
    }
  }, [_vm._v("Chapter 4:   Disillusioned")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5:   A Voice of Comfort Wrapped in Her Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part Two")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6:   A Brand New Chapter Begins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7:   Life Lessons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8:   Beyond Her Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9:   Why Won’t They Listen?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10:   Listen to the Voice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11:   The Big Bad World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part Three:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12:   Deceived")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13:   Question Answered")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14:   A Blessing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15:   Idyllic Persuasion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16:   Would Promises Be Kept?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17:   Another Blessing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18:   Protecting Her Young")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part Four:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19:   Spiraling Downward")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20:   A Different Kind of Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21:   Freedom of a Kind")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22:   A Twenty-One-Day Weekend")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23:   Simple Things")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24:   Making the Most")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25:   A New Adventure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26:   A New Chapter – Going Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part Five:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27:   As the Mirror Cracked")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28:   Picking Up the Pieces")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29:   The Perfect Place")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30:   Guilty As Charged")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31:   Message from Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32:   Too Late for Sorry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33:   End of an Era")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34:   Unrelenting Cruelty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35:   Letters of Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36:   A Shredded Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37:   Illusion Shattered")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38:   The Way Out of Hell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39:   How to explain the Madness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40:   Finding her way Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 41:   Closer and Closer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About The Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3384b7c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter04.vue
// module id = 69
// module chunks = 0